import { createApp } from 'vue'
import { registerSW } from 'virtual:pwa-register'
import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'
import { installTelemetry, reportError } from './lib/telemetry'
import './styles/main.css'

// Auto-update the service worker in the background (new version applies on next load).
// A failed registration used to be silent — and without a service worker there is no
// offline app at all, which is the whole point of the PWA.
registerSW({ immediate: true, onRegisterError: (err) => reportError(err, { kind: 'sw' }) })

const app = createApp(App)
installTelemetry(app)
app.use(router).use(i18n).mount('#app')
